<router-outlet>
  <app-spinner />
  <app-spinner-component />
</router-outlet>
